<!--下拉项列表弹窗-->
<template>
	<el-dialog append-to-body :close-on-press-escape="false" :modal-append-to-body="false" :close-on-click-modal="false" :title="title" :visible.sync="dialogFormVisible" width="800px">
		<el-radio-group v-model="isUrl">
			<el-radio name='type' label="0">手动配置</el-radio>
			<el-radio name='type' label="1">自定义接口</el-radio>
		</el-radio-group>

		<el-form v-if="isUrl == '1'" :model="formSave" ref="formSaveRef" label-width="50px" label-position="right" :rules="rules">
			<div class="grid-content bg-purple-light" style="margin-top: 20px;">
				<el-form-item label="接口: " prop="interface">
					<el-input v-model="formSave.interface" type="textarea" :rows="5" autocomplete="off" placeholder="接口" style="width: 100%"></el-input>
				</el-form-item>
			</div>
		</el-form>

		<div class="conditionConfig basis-page-cls" v-else>
			<section class="basis-cls_table">
				<div class="header">
					<span class="title el-icon-document"> 下拉项配置列表</span>
					<div class="btns">
						<el-button type="primary" size="small" @click="addOption()">新增</el-button>
					</div>
				</div>
				<div class="table">
					<table-pagination :data="list" :column="column" :total="total" :page.sync="queryInfo.pageNum" :limit.sync="queryInfo.pageSize" />
				</div>
			</section>
		</div>

		<div slot="footer" class="dialog-footer" v-if="isUrl == '1'">
			<el-button @click="getCancelBtn()">取 消</el-button>
			<el-button type="primary" @click="commit" :loading="loading">确 定</el-button>
		</div>

		<manageOption ref="manageOption" @requestList="requestOptionList" :itemId="itemId"/>
	</el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import manageOption from "./components/manageOption";

export default {
	name: "optionList",
	components: {
		manageOption
	},
	data() {
		return {
			isUrl: "0",
			reportId: "",
			itemId: "",
			loading: false,
			dialogFormVisible: false,
			formSave: {
				interface: "",
			},
			title: "新建配置项",
			rules: {
				interface: [{ required: true, message: '请输入接口url', trigger: 'blur' }],
			},

			list: [],
			queryInfo: {
				pageNum: 1,
				pageSize: 100,
			},
			total: 100,
			column: [
				{ label: '代码', prop: 'optionCode', minWidth: 100 },
				{ label: '名称', prop: 'optionName', minWidth: 150 },
				{ label: '序号', prop: 'seqNum', width: 100 },
				{ label: '状态', prop: 'optionState', width: 100,
				render: (h, scope) => {
						return <span>{scope.row.optionState == "1"?"启用":"禁用"}</span>
					} },
				{
					label: '操作',
					prop: 'createTime',
					minWidth: 180,
					render: (h, scope) => {
						return (
							<div>
								<el-button type="text" onClick={()=>this.updateOption(scope.row)}>修改</el-button>
								<el-button type="text" onClick={()=>this.deleteOption(scope.row)}>删除</el-button>
							</div>
						)
					}
				},
			],
			//
		}
	},
	computed: {
		...mapGetters([
			'userInfo',
		]),
	},
	mounted() {},
	methods: {
		init() {
			this.resetFormData();
			this.dialogFormVisible = true;
		},

		commit() {
			console.log("commit")
			this.$refs.formSaveRef.validate((valid) => {
				if (valid) {
					this.loading = true;

					let queryData = Object.assign({}, this.formSave);

					this.$api.reportDefinitionOptionInterfaceAddJson({
						itemId: this.itemId,
						interfaceUrl: queryData.interface
					}).then(res => {
						if (!res) return false;
						this.$message.success("操作成功");
						this.$emit("requestList");
						this.dialogFormVisible = false;
					}).finally(() => {
						this.loading = false;
					})
				} else {
					return false;
				}
			});
		},
		// 取消按钮回调
		getCancelBtn() {
			this.resetFormData();
			// this.$refs.formSaveRef.resetFields()
			this.dialogFormVisible = false;
			// this.$emit("requestList");
		},

		requestOptionList() {
			this.$api.reportDefinitionOptionListJson({
				pageNum: 1,
				pageSize: 100,
				data: {
					itemId: this.itemId
				}
			}).then(rs => {
				console.log(rs);
				if (!rs) return false;
				let { data } = rs;

				//待修改，后台接口没时间调试
				if(this.formSave.interface){
					this.isUrl = "1";
					return;
				}
				//--------------------------

				if(typeof data == "string"){
					this.isUrl = "1";
					this.formSave.interface = data;
				}else{
					this.isUrl = "0";
					this.list = data;
				}
			})
		},

		// 打开弹窗
		open(conditionData) {
			this.init();
			this.setFormdata(conditionData)
			this.requestOptionList();
		},
		setFormdata(conditionData) {
			// console.log(conditionData);
			this.itemId = conditionData.itemId;
			this.reportId = conditionData.reportId;
			this.formSave = {
				interface: conditionData.optionInterface
			};
		},

		resetFormData() {
			this.formSave = {
				interface: "",
			};
		},

		addOption(){
			this.$refs.manageOption.addOption();
		},
		updateOption(optionData){
			this.$refs.manageOption.updateOption(optionData);
		},
		deleteOption(optionData) {
			this.$confirm(`是否要删除"${optionData.optionName}"`,'提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$api.reportDefinitionOptionDeleteJson(optionData)
				.then((res) => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					})
					this.requestOptionList();
				})
			})
		},
	}
}
</script>